@if (assistantEnabled() && assistantEntitled()) {
  <ng-template
    #overlay="rtConnectedOverlay"
    rt-connected-overlay
    [origin]="overlayOrigin"
    [positions]="positions"
    [offsetY]="offsetY"
    [offsetX]="offsetX"
    [rtConnectedOverlayAutoClose]="false"
    [hasBackdrop]="true"
    (backdropClick)="overlay.open = false"
  >
    <hr-assistant-chat
      [userAvatar]="userData().avatar"
      [userFullName]="userData().name"
      [conversationStarters]="assistantConfig()?.wiki?.questions ?? []"
      [greeting]="assistantConfig()?.greeting ?? ''"
      (close)="overlay.open = false"
    />
  </ng-template>

  <hr-assistant-trigger
    #overlayOrigin="rtOverlayOrigin"
    rt-overlay-origin
    [forceHoverState]="overlay.open"
    [withHover]="true"
    (click)="overlay.open = !overlay.open; trackTriggerClick()"
  />
}
